import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    headerRow: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    itemContainer: {
        backgroundColor: "transparent",
        flexDirection: "row",
        alignItems: "center"
    },
    modalActions: {
        justifyContent: "flex-end",
        flexDirection: "row"
    },
    itemIcon: {
        justifyContent: "center",
        alignItems: "center",
        height: 48,
        width: 48
    },
    paginationContainer: {
        justifyContent: "center",
        flexDirection: "row",
        alignItems: "center"
    },
    itemActions: {
        flexDirection: "row",
        alignItems: "center"
    },
    itemContent: {
        flexDirection: "row",
        alignItems: "center",
        flex: 1
    },
    formRow: {
        flexDirection: "row"
    },
    modalContent: {
        maxHeight: "90%",
        maxWidth: "90%",
        width: 700
    },
    formContainer: {
    },
    listContent: {
    },
    searchInput: {
    },
    formColumn: {
    },
    container: {
        flex: 1
    },
    itemInfo: {
        flex: 1
    }
});

export default stylesheet;
